<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="609"
          @click:outside="closeModal"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                {{ $t('goals.addFarmZone') }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form ref="addUser" lazy-validation autocomplete="off">
              <v-card-text class="black--text">
                <v-row>
                  <v-col cols="12">
                    <label>{{ $t('goals.selectFarmZone') }}</label>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-select
                      class="custom-select"
                      v-model="type"
                      :items="selectTypeValues"
                      outlined
                      :label="$t('selectType')"
                      hide-details
                      @change="resetForm"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="type === 'Farm'">
                  <v-col cols="12">
                    <v-select
                      v-model="selected.farm"
                      :items="allUserFarms"
                      item-value="id"
                      item-text="farmName"
                      :label="$t('selectFarm')"
                      outlined
                      class="custom-select"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="type === 'Zone'">
                  <v-col cols="12">
                    <v-combobox
                      v-model="selected.segments"
                      :items="allUserSegments"
                      item-value="id"
                      item-text="geofenceName"
                      :label="$t('selectZone')"
                      multiple
                      outlined
                      class="custom-select"
                    ></v-combobox>
                  </v-col>
                </v-row>

                <v-divider class="mt-5"></v-divider>
                <v-card-actions style="padding-right: 0; margin-top: 100px">
                  <v-spacer></v-spacer>
                  <v-btn
                    outlined
                    class="mr-2"
                    right
                    height="44"
                    width="116"
                    depressed
                    color="primary"
                    @click="closeModal"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    right
                    height="44"
                    width="116"
                    color="primary"
                    :disabled="saveIsDisabled()"
                    @click="saveFarmSegmentsSelection"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
import gql from "graphql-tag";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      type: "farm",
      selectTypeValues: ["Farm", "Zone"],
      selected: {
        farm: "",
        segments: [],
      },
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
    ...mapGetters(["getUser"]),
    userId() {
      return Number(this.getUser.id || this.getUser.userDetail.id);
    }
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    farmSegmentsProp: {
      type: Object,
      required: false,
    },
  },
  created() {
    console.log(this.farmSegmentsProp);
    if (this.farmSegmentsProp) {
      if (this.farmSegmentsProp.segments.length > 0) {
        this.type = "Zone";
      } else {
        this.type = "Farm";
      }
      this.selected = this.farmSegmentsProp;
    }
  },
  methods: {
    saveIsDisabled() {
      if (this.selected.farm.length > 0 || this.selected.segments.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    closeModal() {
      this.$emit("closeDialog");
      this.resetForm();
    },
    saveFarmSegmentsSelection() {
      let farmIdToNameObj = {};
      this.allUserFarms?.forEach(f => {
        farmIdToNameObj[f.id] = f.farmName;
      });
      this.$emit("emitFarmSegments", {
        selected: this.selected,
        farmIdToNameObj,
      });
      this.$emit("closeDialog");
    },
    resetForm() {
      this.selected = {
        farm: "",
        segments: [],
      };
    },
  },
  apollo: {
    allUserFarms: {
      query() {
        if (this.userId) {
          return gql`
            query allUserFarms($id: Int!) {
              allUserFarms(id: $id) {
                id
                farmName
              }
            }
          `;
        }
      },
      variables() {
        return {
          id: this.userId,
        };
      },
      update: data => data.allUserFarms,
    },
    allUserSegments: {
      query() {
        if (this.userId) {
          return gql`
            query allUserSegments {
              allUserSegments {
                id
                geofenceName
              }
            }
          `;
        }
      },
      variables() {
        return {
          id: this.getUser.id,
        };
      },
      update: data => data.allUserSegments,
    },
  },
};
</script>

<style scoped>
.v-sheet.v-list:not(.v-sheet--outlined) {
  max-height: 150px;
}

/* .v-text-field--outlined .v-label {
  margin-top: 10px !important;
} */

.custom-select >>> .v-label {
  margin-top: 10px; /* Adjust this value as needed */
}
</style>
